module.exports = __webpack_public_path__ + "img/card-2.6edc5281.png";